import * as React from 'react';
import {useState} from 'react';
import { Grid, Typography,FormControl,Divider, Select,Checkbox, InputBase,MenuItem,ListItemText,Chip, Hidden} from '@material-ui/core';
import { makeStyles} from '@material-ui/core/styles'
import { Theme,withStyles,createStyles } from '@material-ui/core/styles';
import { primaryBlue, primaryGray, searchBarBorderColor } from 'src/components/sub-components/colors/colors';

export function Step4(props) {
    const classes = useStyles()
    const [selectedDevice,setSelectedDevice]=useState([])

    const selectDevice=(e)=>{
      setSelectedDevice(e.target.value)
    }

    const removeItem=(value)=>{
      setSelectedDevice(selectedDevice.filter((d)=>d!==value))
    }
    return (
        <Grid container className={classes.container}>
            <Grid item xs={6} md={6} style={{textAlign:"left",marginBottom:"20px"}}>

                <Typography className={classes.label}>Select Device ID's</Typography>
                <FormControl className={classes.input}>
                  <Select
                      id="demo-customized-select-native"
                      value={selectedDevice}
                      className={classes.input}
                      onChange={selectDevice}
                      multiple
                      renderValue={(selected:string[]) =>
                        <div>
                          {selected.map((value,i) => (
                            <Chip key={i} label={value} 
                              className={classes.chip} 
                              onMouseDown={(event) => {
                                event.stopPropagation();
                              }}
                              onDelete={()=>removeItem(value)}/>
                          ))}
                        </div>
                      }
                      input={<BootstrapInput/>}
                  >
                      {
                          ["Test1","Test2","Test3","Test 4"].map((t,index)=>{
                              return(
                                  <MenuItem value={t} key={index}>
                                      <Checkbox checked={selectedDevice.includes(t)} style={{color:primaryBlue}}/>
                                      <ListItemText primary={t} style={{color:primaryGray}}/>
                                  </MenuItem>
                              )
                          })
                      }
                  </Select>
              </FormControl>
            </Grid>
        </Grid>
    )
}

const useStyles = makeStyles((theme:Theme) => ({
    container:{
        paddingTop:"20px"
    },
    input:{
      width:"100%",
      height:"40px",
      backgroundColor:"#F4F5F7",
    },
    label:{
        fontSize:"15px",
        color:primaryGray,
        paddingBottom:"10px"
    },
    chip:{
      borderRadius:"4px",
      backgroundColor:"#C7C4C436",
      marginLeft:"5px"
    }
}));

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: "white",
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      '&:focus': {
        borderRadius: 4,
        borderColor: searchBarBorderColor,
        backgroundColor: "white",
      },
    },
  }),
)(InputBase);